<template>
    <div
        data-cy="identity"
        class="relative h-full text-gray-700 flex flex-col"
    >
        <div class="pt-5 text-gray-900 font-medium text-xl text-center">
            {{ identificationData.title }}
        </div>
        <div
            v-if="error"
            class="p-4"
        >
            <Error
                :axios-error="error"
            />
        </div>
        <ModuleComponents
            v-else-if="identity"
            :modules="[identity]"
        />
        <div
            v-else
            class="py-10 flex items-center justify-center h-full"
        >
            <UILoading class="w-12 h-12" />
        </div>
    </div>
</template>

<script setup>
    import { useIdentityStore } from '@/stores/identity'

    import ModuleComponents from '@/components/ModuleComponents.vue'
    import Error from '@/components/ui/Error.vue'

    const props = defineProps({
        content: Object,
    })

    const identityStore = useIdentityStore()
    const versionStore = useVersionStore()

    const { identity, error } = storeToRefs(identityStore)
    const { version } = storeToRefs(versionStore)

    const identificationData = computed(() => get(version.value, 'identification_settings'))
</script>
